import React from 'react';
import { Button, Col, Form, Modal, Row } from "react-bootstrap";

import FastTextArea from "../util/FastTextArea";
import FastFormQuestion from '../util/FastFormQuestion';
import FORM_QUESTIONS from '../../step1_questions.json';

export default function FocusProgramDialog(props) {

    const handleClose = () => {
        props.handleCloseDialog()
    }

    const handleCancel = () => {
        props.handleCancelDialog()
    }

    const isFormDisabled = (programId) => {
        if (programId) {
            if (props.stepCompletionData && programId in props.stepCompletionData) {
                return props.stepCompletionData[programId]?.completed
            } else {
                // no completion data found for programId
                // this indicates that the step is incomplete
                return false
            }
            
        }
        return true
    }
    
    return (
        <Modal size="lg" show={props.showModal} onHide={handleCancel}>
            <Modal.Header closeButton>
                <Modal.Title>Focus Area - Edit</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div className="mx-5">
                    <Form>
                        <Form.Group as={Row} className="mb-3" controlId="fp_q1">
                            <Form.Label column sm="4">
                                Department
                            </Form.Label>
                            <Col sm="8">
                                <Form.Label column sm="8" className="text-muted w-100">
                                    {props.department.name}
                                </Form.Label>
                            </Col>
                        </Form.Group>

                        <Form.Group as={Row} className="mb-3" controlId="fp_q1">
                            <Form.Label column sm="4">
                                Program
                            </Form.Label>
                            <Col sm="8">
                                <Form.Label column sm="8" className="text-muted w-100">
                                    {props.selectedProgram?.name}
                                </Form.Label>
                            </Col>
                        </Form.Group>

                        <Form.Group as={Row} className="mb-3" controlId="fp_q1">
                            <Form.Label column sm="4">
                                Theme
                            </Form.Label>
                            <Col sm="8">
                                <Form.Label column sm="8" className="text-muted w-100">
                                    {props.theme ? props.theme.name : 'Unavailable'}
                                </Form.Label>
                            </Col>
                        </Form.Group>

                        <Form.Group as={Row} className="mb-3" controlId="fp_q1">
                            <Form.Label column sm="4" className="fw">
                                Learning Outcome
                            </Form.Label>
                            <Col sm="8">
                                <Form.Label column sm="8" className="text-muted w-100">
                                    {props.selectedLearningOutcome?.text}
                                </Form.Label>
                            </Col>
                        </Form.Group>

                        <Form.Group as={Row} className="mb-3" controlId="fp_q1">
                            <Form.Label column sm="4">
                                <FastFormQuestion 
                                    text={FORM_QUESTIONS["focusQuestion"].text}
                                    required={FORM_QUESTIONS["focusQuestion"].required}
                                    />
                            </Form.Label>
                            <Col sm="8">
                                <FastTextArea
                                    id={"program-" + props.selectedProgram?.programId + "_slo-" + props.selectedLearningOutcome?.sloId + "_q1"}
                                    callback={props.handleS1Q1Changed}
                                    text={props.stepData.s1q1}
                                    disabled={isFormDisabled(props.selectedProgram?.programId)}
                                    maxLength="1024"
                                    />
                            </Col>
                        </Form.Group>
                    </Form>
                </div>
            </Modal.Body>

            <Modal.Footer style={{ display: "flex", justifyContent: "center"}}>
                <Button
                    variant="secondary"
                    onClick={handleCancel}
                    className="p-25"
                    >
                    Cancel
                </Button>
                <Button 
                    variant="primary" 
                    onClick={handleClose}
                    className="p-25"
                    >
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    )
}
